import { useState } from 'react';

export interface LoadingValue<T> {
    loading: boolean;
    error?: any;
    value?: T;
}
export const useLoadingValue = <T>(initialValue?: T, initialLoading = true) => {
    const toInitialState = () => ({
        loading: initialLoading,
        error: undefined,
        value: initialValue,
    });
    const [{ loading, error, value }, setState] = useState<LoadingValue<T>>(toInitialState());

    const setLoading = (nextLoading: boolean) => setState({ loading: nextLoading, value, error });
    const setValue = (nextValue: T) => setState({ loading: false, value: nextValue, error });
    const setError = (nextError: any) => setState({ loading: false, value, error: nextError });
    const reset = () => setState(toInitialState());

    return { loading, error, value, setLoading, setValue, setError, reset };
};
